import { ObjectData } from ".";

export class Winery {

    constructor(
        readonly country: number,
        readonly region: ObjectData,
        readonly subregion: null | ObjectData,
        readonly appellation: null | ObjectData,
        readonly domain: string,
        readonly classification: ObjectData,
        readonly producer: null | string,
        readonly addressStreet: null | string,
        readonly addressCity: null | string,
        readonly addressPostalCode: null | string,
        readonly addressPost: null | string,
        readonly latitude: null | number,
        readonly longitude: null | number,
        readonly phone: null | string,
        readonly email: null | string,
        readonly website: null | string,
        readonly visitingHoursMondayFrom: null | string,
        readonly visitingHoursMondayTo: null | string,
        readonly visitingHoursTuesdayFrom: null | string,
        readonly visitingHoursTuesdayTo: null | string,
        readonly visitingHoursWednesdayFrom: null | string,
        readonly visitingHoursWednesdayTo: null | string,
        readonly visitingHoursThursdayFrom: null | string,
        readonly visitingHoursThursdayTo: null | string,
        readonly visitingHoursFridayFrom: null | string,
        readonly visitingHoursFridayTo: null | string,
        readonly visitingHoursSaturdayFrom: null | string,
        readonly visitingHoursSaturdayTo: null | string,
        readonly visitingHoursSundayFrom: null | string,
        readonly visitingHoursSundayTo: null | string,
        readonly appointmentOnly: boolean,
        readonly plantation: null | number,
        readonly redVarieties: ObjectData[],
        readonly whiteVarieties: ObjectData[],
        readonly labels: ObjectData[],
        readonly photos: number[]
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/api/request/Winery.ts